import { UPDATE_SELLER_WALLET_PLAN_REQUEST, UPDATE_SELLER_WALLET_PLAN_SUCCESS, UPDATE_SELLER_WALLET_PLAN_FAILURE, UPDATE_SELLER_WALLET_PLAN_RESET, } from "../../actions";
const initialState = {
    ActivePlanData: null,
    loading: false,
    error: null,
};
const updateActiveWalletPlanReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SELLER_WALLET_PLAN_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, ActivePlanData: action.payload });
        case UPDATE_SELLER_WALLET_PLAN_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, ActivePlanData: null, error: null });
        case UPDATE_SELLER_WALLET_PLAN_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, ActivePlanData: null });
        case UPDATE_SELLER_WALLET_PLAN_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, ActivePlanData: null, error: null });
        default:
            return state;
    }
};
export default updateActiveWalletPlanReducer;
